import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { HealthAndSafety } from "@mui/icons-material";
import meetSharif  from "../images/about_deb_bg.jpg";

const KeepingUsSafe = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetSharif })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <HealthAndSafety sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Keeping Us Safe
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Sharif will work to make sure every neighborhood
              gets the resources they need to improve public safety. All of our
              residents deserve to be protected in their communities. Sharif has
              consistently voted to support well-funded, professionalized
              public safety departments. She has built dependable relationships
              with the Police and Fire and Rescue Departments and regularly
              brings her constituents’ concerns directly to the appropriate
              agency for attention.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Voted to fund new public safety initiatives, including the body-worn camera program, 911 mental health interventions, and new positions for the Fire and Rescue Department and the Police Department." />
              <Bullet text="Requested swift action by the Police Department to pursue and apprehend drag racers terrorizing neighborhoods with reckless driving and loud modified engines." />
              <Bullet text="Lobbied every budget cycle for a Police Station in downtown Columbia." />
              <Bullet text="Organized community meetings with the Police Department to address unsafe behaviors, problem areas, and other safety concerns reported by constituents." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default KeepingUsSafe;
